import { prefixObjectValues } from '../../../utils';
const form = {
  formDialog: 'dialog',
  form: 'form',
  typeSelect: 'addressType-select',
  line1Input: 'addressLine1-input',
  line2Input: 'addressLine2-input',
  cityInput: 'city-input',
  stateSelect: 'state-select',
  postalCodeInput: 'postalCode-input',
  countrySelect: 'country-select',
  submitBtn: 'submit-btn',
};

export default prefixObjectValues(form, 'profile-address-form');
